$(".buy-now-track").click(function(){
    console.log($(this).attr("price"))
    // fbq('track', 'Purchase', {
    //     currency: "USD", 
    //     value: parseFloat($(this).attr("price")), 
    //     content_ids: [$(this).attr("href")], 
    //     content_type: "product"
    // });
    fbq('trackCustom', 'BuyOnPrime'); 

    // ttq.track('Purchase', {
    //     currency: 'USD', 
    //     value: parseFloat($(this).attr("price")), 
    //     content_ids: $(this).attr("href"), 
    //     content_type: "product"
    // });

    ttq.track('BuyOnPrime');
    
    gtag('event', 'conversion', { 
        'send_to': 'AW-11140647690/u1f_CKqG3v4YEIqWo8Ap', 
        'transaction_id': $(this).attr("href"), 
    }); 
})

document.addEventListener("DOMContentLoaded", function () {
    
    // Product page show/hide ingredients
    const toggleTitle = document.querySelector(".product-logo-title");
    const ingredientsSection = document.querySelector(".ingredients");
    const container = document.querySelector(".product-logo-title");
  
    toggleTitle.addEventListener("click", function () {
        ingredientsSection.classList.toggle("show");
      container.classList.toggle("open"); // This triggers CSS chevron switch
    });

    // Insta feed slider
    const feedWrapper = document.querySelector('.instafeed-new-layout-wrapper');
    const item = feedWrapper.querySelector('.instafeed-new-layout-item');

    if (feedWrapper && item) {
      const halfItemWidth = item.offsetWidth / 2;
      feedWrapper.style.transform = `translateX(-${halfItemWidth}px)`;
    }

});
